import React from "react";
import { FileOutput } from "lucide-react";

/* ===================== STYLES ===================== */
import styles from "./ResponseBodyParams.module.scss";

const ResponseBodyParams = ({ params = [], isAdminView = false }) => {
  const columns = isAdminView ? 4 : 3;

  return (
    <div className={styles["admin-res-body-params__card"]}>
      {/* HEADER */}
      <div className={styles["admin-res-body-params__header"]}>
        <div className={styles["admin-res-body-params__icon-wrapper"]}>
          <FileOutput size={18} strokeWidth={2.5} />
        </div>
        <h3 className={styles["admin-res-body-params__title"]}>
          Response Body Parameters
        </h3>
      </div>

      {/* TABLE */}
      <div className={styles["admin-res-body-params__table-wrapper"]}>
        <table className={styles["admin-res-body-params__table"]}>
          <thead>
            <tr>
              <th className={styles["admin-res-body-params__th"]}>Parameter</th>
              {isAdminView && (
                <th className={styles["admin-res-body-params__th"]}>Value</th>
              )}
              <th className={styles["admin-res-body-params__th"]}>Data Type</th>
              <th className={styles["admin-res-body-params__th"]}>
                Description
              </th>
            </tr>
          </thead>

          <tbody>
            {params.length > 0 ? (
              params.map((item, index) => (
                <tr key={index} className={styles["admin-res-body-params__tr"]}>
                  <td className={styles["admin-res-body-params__td"]}>
                    <span className={styles["admin-res-body-params__name"]}>
                      {item.name}
                    </span>
                  </td>

                  {isAdminView && (
                    <td className={styles["admin-res-body-params__td"]}>
                      {item.value || "--"}
                    </td>
                  )}

                  <td className={styles["admin-res-body-params__td"]}>
                    <span
                      className={`${styles["admin-res-body-params__badge"]} ${styles["admin-res-body-params__badge--type"]}`}
                    >
                      {item.data_type}
                    </span>
                  </td>

                  <td className={styles["admin-res-body-params__td"]}>
                    {item.description}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns}
                  className={styles["admin-res-body-params__empty"]}
                >
                  No response body parameters available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ResponseBodyParams;
